import { SigninDto } from './../dtos/auth/request/signinDto';
import config from "../config";
import { JwtTokenDto } from "../dtos/auth/response/jwtTokenDto";
import { ResponseDto } from "../dtos/common/responseDto";
import { UserResponseDto } from "../dtos/user/response/userResponseDto";
import { getData,  postData } from "../utils/axios/serverHelper";
import { FindIdDto } from '../dtos/auth/request/findIdDto';
import { TempPasswordRequestDto } from 'src/dtos/auth/request/tempPasswordRequestDto';
import { MenuDto } from '../dtos/menu/menuDto';
import { encryptPassword } from "../utils/auth/passwordEncrypt";

const baseUrl = `${config.apiUrl}/auth`;


export const signin = async (userId: string, userPassword: string) => {
    const url = `${baseUrl}/signin`;

    const payload = {
        userId,
        userPassword: encryptPassword(userPassword)
    };

    // if (process.env.NODE_ENV !== "production") {
    //     console.log("[authApi] signin payload", payload);
    // }

    return await postData<SigninDto, ResponseDto<JwtTokenDto>>(url, {
        ...payload
    })
}

// 아이디찾기 
export const findId = async (empNm: string, phoneNumber: string) => {
    const url = `${baseUrl}/find/id`;

    return await postData<FindIdDto, ResponseDto<string>>(url, {
        empNm, phoneNumber
    })
}

// // 비밀번호찾기
// export const findPassword = async (
//     userName: string,
//     phoneNumber: string,
//     userId: string) => {
//
//     const url = `${baseUrl}/password`;
//
//     return await patchData<ChangePasswordDto, ResponseDto<any>>(url, {
//         userName, phoneNumber, userId
//     })
// }

// 임시 비밀번호 발급
export const issueTempPassword = async (
    userId: string,
    empNm: string,
    phoneNumber: string
) => {
    const url = `${baseUrl}/password/temp`;

    return await postData<TempPasswordRequestDto, ResponseDto<string>>(url, {
        userId,
        empNm,
        phoneNumber
    });
}


export const getMenuAuth = async (menuCd: string) => {
    const url = `${baseUrl}/${menuCd}`;
    return await getData<MenuDto>(url);
};



export const getUserBySearch = async (keyword: string) => {
    const url = `${baseUrl}/modal`

    return await getData<ResponseDto<UserResponseDto[]>>(url, {
        params: { keyword }  
    });
}

//  RefreshToken으로 새 토큰 발급
export const refreshTokens = async (refreshToken: string) => {
    const url = `${baseUrl}/refresh`;

    return await postData<{ refreshToken: string }, ResponseDto<JwtTokenDto>>(url, {
        refreshToken
    });
}

export const logout = async () => {
    const url = `${baseUrl}/logout`;
    return await postData<void, ResponseDto<void>>(url);
}

